import { useMemo } from 'react';
import { DateRangeValuePiece } from 'common/components/Inputs/DateRangePickerMui/DateRangePickerMui.tsx';

type UseDataRangeParseProps = {
  from: Date | null;
  to: Date | null;
};

export const useDataRangeCopy = ({ from, to }: UseDataRangeParseProps) => {
  return useMemo(() => {
    const fromDate = from ? new Date(from) : null;
    const toDate = to ? new Date(to) : null;
    return [fromDate, toDate] as [DateRangeValuePiece, DateRangeValuePiece];
  }, [from, to]);
};
